'use client'

import { TRoomDetail } from '@/entities/room'
import { formatCurrency, useMultiScrollState } from '@/shared/lib'
import { Notice } from '@/shared/ui'

import { TabValue } from '../../lib/tab'
import { Heading, Item, Label, List, Value, Discounts } from '../common'

type Props = Pick<
  TRoomDetail,
  | 'earlyCheckinDiscounts'
  | 'longTermDiscounts'
  | 'usingFee'
  | 'mgmtFee'
  | 'cleanFee'
  | 'deposit'
>

export const ContractInformation = ({
  earlyCheckinDiscounts,
  longTermDiscounts,
  usingFee,
  mgmtFee,
  cleanFee,
  deposit,
}: Props) => {
  const { registerScrollElement } = useMultiScrollState<HTMLElement>()

  return (
    <section
      className="bg-gray-0 flex gap-30 rounded-sm p-6"
      ref={element => {
        if (element) {
          registerScrollElement(TabValue.CONTRACT_INFORMATION, element)
        }
      }}
    >
      <Heading>계약 정보</Heading>

      <div className="grow space-y-3">
        <div className="rounded-sm bg-white p-7.5">
          <List spacing="small" className="typo-body2">
            <Item className="flex-col justify-start gap-2.5">
              <div className="flex w-full items-center justify-between gap-2">
                <Label className="font-semibold">임대료</Label>
                <Value className="font-medium">
                  {formatCurrency(usingFee)}원 / 1주
                </Value>
              </div>
              <Discounts
                earlyCheckinDiscounts={earlyCheckinDiscounts}
                longTermDiscounts={longTermDiscounts}
                highlightColor="gray"
                className="w-full"
              />
            </Item>
            <Item className="justify-between">
              <Label className="font-semibold">관리비</Label>
              <Value className="font-medium">
                {formatCurrency(mgmtFee)}원 / 1주
              </Value>
            </Item>
            <Item className="justify-between">
              <Label className="font-semibold">청소비</Label>
              <Value className="font-medium">
                {formatCurrency(cleanFee)}원
              </Value>
            </Item>
            <Item className="justify-between">
              <Label className="font-semibold">보증금</Label>
              <Value className="font-medium">{formatCurrency(deposit)}원</Value>
            </Item>
          </List>
        </div>

        <Notice.Title className="font-normal">
          보증금은 삼삼엠투에서 보관하며, 퇴실 후 반환됩니다.
        </Notice.Title>
      </div>
    </section>
  )
}
